import {
  deepClone,
  EditorActionsManager,
  IVector3,
  UpdateDataAction,
  VirtualChildComponent,
  VirtualChildData,
} from '@easytwin/runtime';
import { set } from 'lodash-es';
import * as React from 'react';
import { ImmerFormItem } from '@/UIGenerator/uicomponents/ImmerFormItem';
import { ProInput, Vector3FormItem } from '@/UIGenerator';
import { CopyIdNode } from './CopyIdNode';

interface VirtualChildDataPositionProps {
  comp: VirtualChildComponent;
  compJson: VirtualChildData<{ position: IVector3 }>;
  mode?: 'lonLat' | 'xyz';
}

export const VirtualChildDataPosition: React.FC<VirtualChildDataPositionProps> = (props) => {
  const { comp, compJson, mode = 'xyz' } = props;

  const [showValue, setShowValue] = React.useState<IVector3>(compJson.config.position);
  const editorActionMgr = comp.engine.getManager(EditorActionsManager);

  const handleUpdate = (name: string, value: IVector3 | string | undefined) => {
    if (!compJson) return;
    const newData = deepClone(compJson);

    if (name === 'config.position') {
      if (mode === 'xyz') {
        set(newData, name, value);
      } else {
        const res = comp.scene.geoTransform.geoToScene({
          longitude: (value as IVector3).x,
          latitude: (value as IVector3).y,
          altitude: (value as IVector3).z,
        });
        set(newData, name, res);
      }
    } else {
      set(newData, name, value);
    }
    comp.updateData(newData, false);
  };

  const handleConfirm = (name: string, value: IVector3 | string | undefined) => {
    if (!compJson) return;
    const newData = deepClone(compJson);
    if (name === 'config.position') {
      if (mode === 'xyz') {
        set(newData, name, value);
      } else {
        const res = comp.scene.geoTransform.geoToScene({
          longitude: (value as IVector3).x,
          latitude: (value as IVector3).y,
          altitude: (value as IVector3).z,
        });
        set(newData, name, res);
      }
    } else {
      set(newData, name, value);
    }

    editorActionMgr.execute(new UpdateDataAction(comp, newData));
  };

  React.useEffect(() => {
    if (compJson) {
      const target = compJson.config.position;
      if (mode === 'lonLat') {
        const res = comp.scene.geoTransform.sceneToGeo(target);
        setShowValue({
          x: res.longitude,
          y: res.latitude,
          z: res.altitude,
        });
      } else {
        setShowValue(target);
      }
    } else {
      // setCode('');
    }
  }, [compJson, mode]);

  return (
    <div>
      <ImmerFormItem label='ID'>
        <ProInput
          disabled
          name='id'
          suffix={<CopyIdNode id={compJson.id} />}
          value={compJson.id}
          onBlur={handleConfirm}
        />
      </ImmerFormItem>
      <ImmerFormItem label='名称'>
        <ProInput
          name='name'
          allowEmpty={false}
          onChange={handleUpdate}
          onBlur={handleConfirm}
          value={compJson.name}
        />
      </ImmerFormItem>
      {mode === 'xyz' ? (
        <Vector3FormItem
          label={'点位数据'}
          name='config.position'
          onChange={handleUpdate}
          onBlur={handleConfirm}
          value={showValue}
        />
      ) : (
        <Vector3FormItem
          label={'点位数据'}
          name='config.position'
          onChange={handleUpdate}
          onBlur={handleConfirm}
          value={showValue}
          hideZ
          prefix={['经度', '纬度', '高度']}
        />
      )}
    </div>
  );
};
